import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { QRCodeCanvas } from 'qrcode.react';
import GetAppRoundedIcon from '@material-ui/icons/GetAppRounded';
import { getInvitationInfo } from './api';
import {
  PageWrapper,
  Card,
  Greeting,
  EventLabel,
  QRContainer,
  InstructionText,
  SaveButton,
  FooterText,
  ErrorTitle,
  ErrorSubtitle,
} from './styledComponents';

export default function PaseInvitacion() {
  const { search } = useLocation();
  const token = new URLSearchParams(search).get('q');
  const qrRef = useRef(null);

  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!token) {
      setError(true);
      setLoading(false);
      return;
    }

    getInvitationInfo(token)
      .then(data => setInfo(data.data))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [token]);

  const handleGuardar = useCallback(() => {
    const canvas = qrRef.current?.querySelector('canvas');
    if (!canvas) return;

    const link = document.createElement('a');
    link.download = 'invitacion.png';
    link.href = canvas.toDataURL('image/png');
    link.click();
  }, []);

  if (loading) return <PageWrapper />;

  if (error || !info) {
    return (
      <PageWrapper>
        <Card>
          <ErrorTitle>Invitación no encontrada</ErrorTitle>
          <ErrorSubtitle>
            El enlace no es válido o ya no está disponible.
          </ErrorSubtitle>
        </Card>
      </PageWrapper>
    );
  }

  return (
    <PageWrapper>
      <Card>
        <Greeting>Hola, {info.fullName}</Greeting>
        <EventLabel>{info.campaignTitle}</EventLabel>
        <QRContainer ref={qrRef}>
          <QRCodeCanvas
            value={token}
            size={256}
            fgColor="#1b5c2e"
            bgColor="#ffffff"
            level="H"
          />
        </QRContainer>
        <InstructionText>
          Muestra este código al entrar al evento
        </InstructionText>
        <SaveButton type="button" onClick={handleGuardar}>
          <GetAppRoundedIcon />
          Guardar invitación
        </SaveButton>
        <FooterText>
          Guárdala en tu galería para no buscar el enlace el día del evento
        </FooterText>
      </Card>
    </PageWrapper>
  );
}
